import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '../ui/dialog';

/**
 * SignatureCaptureDialog — the "Sign document" modal for a Requester/Admin
 * signature-type sender_fillable field. Pure presentation; all state
 * (signing mode, typed value, the SignaturePad instance, save/cancel
 * behaviour) is owned by useSenderFillableFields — pass its returned
 * values straight through as props.
 */
export default function SignatureCaptureDialog({
  open,
  onOpenChange,
  mode,
  onModeChange,
  typedValue,
  onTypedValueChange,
  canvasRef,
  onClearCanvas,
  onCancel,
  onSave,
  testIds = {},
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid={testIds.dialog}>
        <DialogHeader>
          <DialogTitle>Sign document</DialogTitle>
        </DialogHeader>
        <div className="flex gap-2 mb-3">
          <Button type="button" size="sm" variant={mode === 'draw' ? 'default' : 'outline'} onClick={() => onModeChange('draw')}>
            Draw
          </Button>
          <Button type="button" size="sm" variant={mode === 'type' ? 'default' : 'outline'} onClick={() => onModeChange('type')}>
            Type
          </Button>
        </div>
        {mode === 'draw' ? (
          <div className="space-y-2">
            <canvas
              ref={canvasRef}
              width={420}
              height={150}
              className="w-full border border-border rounded-lg bg-white touch-none"
              data-testid={testIds.canvas}
            />
            <Button type="button" size="sm" variant="ghost" onClick={onClearCanvas}>
              Clear
            </Button>
          </div>
        ) : (
          <Input
            value={typedValue}
            onChange={(e) => onTypedValueChange(e.target.value)}
            placeholder="Type your full name"
            className="italic"
            style={{ fontFamily: 'Georgia, "Times New Roman", serif' }}
            autoFocus
          />
        )}
        <DialogFooter>
          <Button type="button" variant="outline" onClick={onCancel}>
            Cancel
          </Button>
          <Button type="button" onClick={onSave} data-testid={testIds.save}>
            Save signature
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
